import { Cell } from "./Cell";

export const EmptyRow = () => {
  const emptyCells = Array.from(Array(5));

  return (
    <div className="grid-row">
      {emptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    </div>
  );
};
